@if (report.id > -1) {
  <div class="report-container" [ngClass]="{'large': size==='large'}" (click)="showReport(report)">
    <img [src]="getThumbnail()" class="sample-report" [ngClass]="{'large': size==='large'}">
    <div class="report-like" [ngClass]="{'report-like-large': size==='large'}">
      @if (!isFavorite()) {
        <mat-icon class="report-like-icon" (click)="setFavorite(true, $event)">favorite_border</mat-icon>
      }
      @if (isFavorite()) {
        <mat-icon class="report-like-icon" (click)="setFavorite(false, $event)">favorite</mat-icon>
      }
    </div>
    <div class="report-info">
      <hr>
        <div class="report-title">
          {{report.title}}
        </div>
        <app-report-rating [report]="report"></app-report-rating>
        <div class="report-description">{{report.description}}</div>
        <div class="report-category">
          <hr>
            @for (category of report.categories; track category) {
              <div class="report-category-item">{{category}}</div>
            }
          </div>
        </div>
      </div>
    }